import React from 'react'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import { useAppState, useDispatch, setFormTab } from 'state'
import { FormTab } from 'models'

const useStyles = makeStyles({
  root: {
    paddingTop: '.4rem',
  },
  active: {
    fontWeight: 600,
    background: '#303030',
    borderRadius: '4px',
  },
  inactive: {
    fontWeight: 400,
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignContent: 'center',
    alignItems: 'center',
  },
  tab: {
    width: '33%',
    padding: '.4rem',
    fontSize: '16px',
    cursor: 'pointer',
  },
})

const FormTabs = () => {
  const styles = useStyles()
  const { formTab } = useAppState()
  const dispatch = useDispatch()
  return (
    <Box className={clsx(styles.root, styles.flex)}>
      <Typography
        className={clsx(styles.tab, formTab === FormTab.BORROW ? styles.active : styles.inactive)}
        align="center"
        onClick={() => dispatch(setFormTab(FormTab.BORROW))}
      >
        Borrow
      </Typography>
      <Typography
        className={clsx(styles.tab, formTab === FormTab.DEPOSIT ? styles.active : styles.inactive)}
        align="center"
        onClick={() => dispatch(setFormTab(FormTab.DEPOSIT))}
      >
        Deposit
      </Typography>
      <Typography
        className={clsx(styles.tab, formTab === FormTab.WITHDRAW ? styles.active : styles.inactive)}
        align="center"
        onClick={() => dispatch(setFormTab(FormTab.WITHDRAW))}
      >
        Withdraw
      </Typography>
    </Box>
  )
}

export default FormTabs
